import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { axiosInstance } from '../../axios';
import useAuth from '../hooks/useAuth';
import users from '../../Users.json';
import './Login.css';
import ErrorPage from '../ErrorPage/ErrorPage';

function Login({ onSubmitForm, showWarning, showSuccess, showError }) {
    const { setAccessToken, setCSRFToken } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const fromLocation = location?.state?.from?.pathname || '/'
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState()
    const [password, setPassword] = useState();
    const [incorrectPassword, setIncorrectPassword] = useState(false);

    // Create new User
    async function CreateNewUser(userData) {
        setLoading(true)

        try {
            const response = await axiosInstance.post('register', JSON.stringify({
                "name": userData.name,
                "email": userData.email,
                "username": userData.username,
                "business_number": userData.company_number,
                "department": userData.department,
                "position": userData.position,
                "password": "123",
                "block": false,
                "image": userData.img
            }))
            if (response?.status == 200) {
                setEmail(userData.email)
                setPassword("123")
                onSubmitForm()
            }
        } catch (error) {
            setLoading(false)
            // TODO: handle errors
        }
    }

    // function to find a user by email
    const findUserByEmail = (email) => {
        return users.find(user => user.email === email);
    }


    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    // async function onSubmitForm(event) {
    //     event.preventDefault()

    //     setLoading(true)

    //     // Find user by email in Json data
    //     const jsonUser = findUserByEmail(email);

    //     if (jsonUser) {
    //         try {
    //             const response = await axiosInstance.post('login', JSON.stringify({
    //                 email,
    //                 password
    //             }))
    //             console.log("testdd")

    //             if (response?.status == 200) {
    //                 setEmail()
    //                 setPassword()
    //                 setLoading(false)

    //                 navigate(fromLocation, { replace: true });
    //                 window.location.reload();
    //             } else {

    //                 console.log("test")
    //             }
    //             // else if (response?.data == "Incorrect password!") {
    //             //     console.log("Incorrect password!");
    //             // }
    //         } catch (error) {
    //             setLoading(false)
    //             // if (error?. == 'User not found!') {
    //             //     console.log("User not found!")
    //             //     CreateNewUser(jsonUser);

    //             // }
    //             console.log(error)
    //             // TODO: handle errors
    //         }
    //     } else {
    //         console.log("error login");
    //     }
    // }

    async function onSubmitForm(event) {
        event.preventDefault();
        setLoading(true);

        // Find user by email in JSON data
        const jsonUser = findUserByEmail(email);

        try {
            // Attempt to login
            const response = await axiosInstance.post('login', {
                email,
                password
            });

            if (response?.status === 200) {
                // Successful login
                navigate(fromLocation, { replace: true });
                window.location.reload();
            } else {
                console.log("Login failed");
            }
        } catch (error) {
            // If user not found in Django, register and then log in
            if (error?.response?.data?.detail === 'User not found!' && jsonUser) {
                console.log("here is json found")
                console.log({
                    "name": jsonUser.username,
                    "email": jsonUser.email,
                    "username": jsonUser.username,
                    "business_number": jsonUser.company_number,
                    "department": jsonUser.department,
                    "position": jsonUser.position,
                    "password": "123",
                    "block": false,
                    "image": jsonUser.img
                })
                // Register user
                await axiosInstance.post('register', {
                    "name": jsonUser.username,
                    "email": jsonUser.email,
                    "username": jsonUser.username,
                    "business_number": jsonUser.company_number,
                    "department": jsonUser.department,
                    "position": jsonUser.position,
                    "password": "123",
                    "block": false,
                    "image": jsonUser.img
                })

                // Attempt to login again
                const loginResponse = await axiosInstance.post('login', {
                    email,
                    password
                });

                if (loginResponse?.status === 200) {
                    navigate(fromLocation, { replace: true });
                    window.location.reload();
                } else {
                    console.log("Error after registration");
                }
            }else if(error?.response?.data?.detail === 'Incorrect password!'){
                showError("잘못된 비밀번호입니다!")
                setIncorrectPassword(true);
            }else {
                console.log("Login error: ", error);
            }
        } finally {
            setLoading(false);
        }
    }


    return (
        <>
        <ErrorPage/>
        </>
        // <div className="login">
        //     <div className="login-content">

        //         <form onSubmit={onSubmitForm}>
        //             <img src={window.location.origin + '/daewoong.png'} width="200" className="mx-auto d-block " alt="" />
        //             <div className="text-body text-opacity-50 text-center mb-4">
        //                 ABM 회의록 통합 관리 시스템
        //             </div>
        //             <div className="mb-3">
        //                 <label className="form-label">Email Address <span className="text-danger">*</span></label>
        //                 <input
        //                     type="text"
        //                     className="form-control form-control-lg fs-body"
        //                     value={email}
        //                     placeholder="Enter your email"
        //                     onChange={handleEmailChange}
        //                 />
        //             </div>
        //             <div className="mb-3">
        //                 <div className="d-flex">
        //                     <label className="form-label">Password <span className="text-danger">*</span></label>
        //                     {/* <a href="#" className="ms-auto text-body text-decoration-none text-opacity-50">
        //                         Forgot password?
        //                     </a> */}
        //                 </div>
        //                 <input
        //                     type="password"
        //                     className= {incorrectPassword ? 'form-control form-control-lg is-invalid' : 'form-control form-control-lg'}
        //                     value={password}
        //                     placeholder="Enter your password"
        //                     onChange={handlePasswordChange}
        //                 />
        //             </div>
        //             {/* <div className="mb-3">
        //                 <div className="form-check">
        //                     <input
        //                         className="form-check-input"
        //                         type="checkbox"
        //                         value=""
        //                         id="customCheck1"
        //                     />
        //                     <label className="form-check-label" htmlFor="customCheck1">
        //                         Remember me
        //                     </label>
        //                 </div>
        //             </div> */}
        //             <button type="submit" className="btn btn-theme btn-lg d-block w-100 fw-semibold mb-3">
        //                 Sign In
        //             </button>
        //             <div className="text-center text-body text-opacity-50">
        //                 비밀번호: 123
        //             </div>
        //             {/* <div className="text-center text-body text-opacity-50">
        //                 Don't have an account yet? <a href="/register">Sign up</a>.
        //             </div> */}
        //         </form>
        //     </div>
        // </div>
    );
}

export default Login;
